// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"5bc2df88","660":"276ab31b"}[chunkId] + ".chunk.css";
};